<app-wrapper [severity]="severity">
    <div class="helper-container">
        <mat-icon>{{ icon }}</mat-icon>
        <div class="helper-content">
            <div class="ng-content-container">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</app-wrapper>